

export default class StsA360RegStep2UsernamePostModel  {
  id: string;
  email: string;
  username: string;
}
